import { collection,getDocs, query, getDoc, doc, orderBy, where, updateDoc, addDoc, deleteDoc, deleteField, Timestamp, writeBatch, QueryDocumentSnapshot, DocumentData, limit, startAfter, getCountFromServer, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { PointAdjustHistory, AdjustUsers, PointAdjustHistoryTimestampToDate, PointCategory, PtCategorySettings, 
  PointType, PointHistoryData, pointDataTimestampToDate, PtAwardedSettings, ptAwardedSettingsTimestampToDate, PtBonusSettings, ptBonusSettingsTimestampToDate,} from "../model/PointData";
import { PointTypeId } from "../config/const";

const master = "master";

const pointDataQuery = {  
  // ポイントカテゴリ一覧を取得
  getPointCategoryList: async () => {
    console.log("pointData getPointCategoryList access");
    const pointCategoryRef = await getDocs(
      query(
        collection(db, `pointData/${master}/pointCategory`),
        orderBy("sortKey", "asc")
      )
    );
    return pointCategoryRef.docs.map((doc) => doc.data() as PointCategory);
  },

  // ポイントカテゴリ設定一覧を取得
  getPtCategorySettingsList: async (tenantId: string) => {
    console.log("pointData getPtCategorySettingsList access");
    const ptCategorySettingsRef = await getDocs(
      query(
        collection(db, `pointData/${tenantId}/ptCategorySettings`),
        orderBy("categoryId", "asc")
      )
    );
    return ptCategorySettingsRef.docs.map((doc) => doc.data() as PtCategorySettings);
  },

  // ポイントタイプ一覧を取得
  getPointTypeList: async () => {
    console.log("pointData getPointTypeList access");
    const pointTypeRef = await getDocs(
      query(
        collection(db, `pointData/${master}/pointType`),
        orderBy("sortKey", "asc")
      )
    );
    return pointTypeRef.docs.map((doc) => doc.data() as PointType);
  },

  // ポイント調整履歴一覧を取得
  getPointAdjustHistoryList: async (tenantId: string) => {
    console.log("pointData getPointAdjustHistoryList access");
    const adjustHistoryRef = await getDocs(query(collection(db, `pointData/${tenantId}/pointAdjustHistory`)));
    return adjustHistoryRef.docs.map((doc) => PointAdjustHistoryTimestampToDate(doc.data()) as PointAdjustHistory);
  },

  // ポイント調整履歴を取得
  getPointAdjustHistory: async (tenantId: string, adjustHistoryId: string) => {
      console.log("message getPointAdjustHistory access");
      const adjustHistoryRef = await getDoc(doc(db, `pointData/${tenantId}/pointAdjustHistory`, adjustHistoryId));
      return PointAdjustHistoryTimestampToDate(adjustHistoryRef.data());
    },

  // ポイント調整対象者一覧を取得
  getAdjustUsersList: async (tenantId: string, adjustHistoryId: string) => {
    console.log("pointData getAdjustUsersList access");
    const adjustUsersRef = await getDocs(query(collection(db, `pointData/${tenantId}/pointAdjustHistory/${adjustHistoryId}/adjustUsers`)));
    return adjustUsersRef.docs.map((doc) => doc.data() as AdjustUsers);
  },

  //ポイント調整履歴＋ポイント調整対象者の新規登録
  addPointAdjustHistory: async (tenantId: string, data: PointAdjustHistory, adjustUsersList: AdjustUsers[]): Promise<void> => {
    console.log("pointData addPointAdjustHistory batch access");
    const batch = writeBatch(db);

    const historyRef = doc(collection(db, `/pointData/${tenantId}/pointAdjustHistory`));
    data.id = historyRef.id;
    batch.set(historyRef, data);

    adjustUsersList.forEach((adjustUser) => {
      adjustUser.pointAdjustHistoryId = data.id;
      const userRef = doc(collection(db, `/pointData/${tenantId}/pointAdjustHistory/${data.id}/adjustUsers`));
      adjustUser.id = userRef.id;
      batch.set(userRef, adjustUser);
    });

    await batch.commit();
    console.log("PointAdjustHistory + AdjustUsers batch write completed");
  },

  //ポイント調整対象者の新規登録
  addAdjustUsers: async (tenantId: string, adjustUser: AdjustUsers, adjustHistoryId: string): Promise<void> => {
    console.log("pointData addAdjustUsers access");
    adjustUser.pointAdjustHistoryId = adjustHistoryId;
    const docRef = await addDoc(
      collection(db, `/pointData/${tenantId}/pointAdjustHistory/${adjustHistoryId}/adjustUsers`),
      adjustUser);
    await updateDoc(
      docRef, {id: docRef.id});
  },

  createPointAdjustHistory: async (tenantId: string, data: PointAdjustHistory) => {
    console.log("pointData createPointAdjustHistory access");
    const currentUser = auth.currentUser;
    const docRef = doc(collection(db, `/pointData/${tenantId}/pointAdjustHistory`));
    const safeData = {
      ...data,
      id: docRef.id,
      tenantId,
      createUser: currentUser?.displayName ?? "",
      ptName: data.ptName || "",
      ptTypeName: data.ptTypeName || "",
      note: data.note || "",
      grantPoints: data.grantPoints ?? 0,
      occurrenceDate: data.occurrenceDate || new Date(),
      createAt: data.createAt || new Date(),
      updateAt: data.updateAt || new Date(),
    };

    await setDoc(docRef, safeData);
    return docRef;
  },

  // 利用者ポイント履歴一覧を取得
  getUserPointHistoryList: async (tenantId: string, userId: string): Promise<any | PointHistoryData> => {
    console.log("pointData getUserPointHistoryList access");
      const docsRef = await getDocs(
        query(
          collection(db, `pointData/${tenantId}/pointHistory`),
          where('userId', '==', userId),
        )
      );
      return docsRef.docs.map((doc) => pointDataTimestampToDate(doc.data()));
  },

  //ポイント履歴一覧を取得
  getPointHistoryList: async (tenantId: string): Promise<any | PointHistoryData> => {
    console.log("pointData getPointHistoryList access");
      const docsRef = await getDocs(
        query(
          collection(db, `pointData/${tenantId}/pointHistory`),
        )
      );
      return docsRef.docs.map((doc) => pointDataTimestampToDate(doc.data()));
  },

  //ポイント履歴の新規登録
  addPointHistory: async (tenantId: string, data: PointHistoryData): Promise<void> => {
    console.log("pointData addPointHistory access");
    const docRef = doc(collection(db, `/pointData/${tenantId}/pointHistory`));
    data.id = docRef.id;
    await setDoc(docRef, data);
  },

  //ポイント付与項目設定取得
  getPtAwardedSettings: async (tenantId: string) => {
    console.log("pointData getPtAwardedSettings access");
    const docsRef = await getDocs(
      query(
        collection(db, `pointData/${tenantId}/ptAwardedSettings`),
        ...[orderBy('typeId', 'asc'), orderBy('name', 'asc')]
      )
    );
    return docsRef.docs.map((doc) => ptAwardedSettingsTimestampToDate(doc.data() as PtAwardedSettings));
  },

  //ポイント付与項目設定取得
  getPtAwardedSettingsForId: async (tenantId: string, id: string) => {
    console.log("pointData getPtAwardedSettingsForId access");
    const docsRef = await getDoc(doc(db, `pointData/${tenantId}/ptAwardedSettings`, id));
    return ptAwardedSettingsTimestampToDate(docsRef.data() as PtAwardedSettings);
  },

  //ポイント付与項目設定取得：タイプID指定
  getPtAwardedSettingsByTypeId: async (tenantId: string, ... typeId: string[]) => {
    console.log(`pointData getPtAwardedSettingsByTypeId access [typeId] ${typeId}`);
    const docsRef = await getDocs(
      query(
        collection(db, `pointData/${tenantId}/ptAwardedSettings`),
        where('typeId', 'in', typeId),
        where('status', '==', 1),
      )
    );
    return docsRef.docs.map((doc) => ptAwardedSettingsTimestampToDate(doc.data() as PtAwardedSettings));
  },

  //ポイント付与項目設定取得：ポイント名指定
  getPtAwardedSettingsByName: async (tenantId: string, name: string) => {
    console.log(`pointData getPtAwardedSettingsByTypeId access name ${name}`);
    const docsRef = await getDocs(
      query(
        collection(db, `pointData/${tenantId}/ptAwardedSettings`),
        where('name', '==', name),
      )
    );
    return docsRef.docs.map((doc) => doc.data() as PtAwardedSettings);
  },

  // ポイントカテゴリ設定更新
  updatePtCategorySettings: async (tenantId: string, data: PtCategorySettings): Promise<void> => {
    console.log("pointData updatePtCategorySettings access");
    // tenantId = "O99900000001-awaet"; //テスト用コード。削除する
    const updateData: any = {
      id: data.id,
      tenantId: tenantId,
      categoryId: data.categoryId,
      categoryName: data.categoryName,
      limitPointFlg: data.limitPointFlg,
      numberOfGrantsMap: data.limitPointFlg === true ? data.numberOfGrantsMap : deleteField(),
      expireFlg: data.expireFlg,
      dateOfExpiryMap: data.expireFlg === true ? data.dateOfExpiryMap : deleteField(),
      updateAt: new Date(),
    };
    if ((updateData.expireFlg === true) && (updateData.dateOfExpiryMap?.expirationUnit === 'limitMonth') && (updateData.dateOfExpiryMap.expirationYm)) {
      updateData.dateOfExpiryMap.expirationYm = Timestamp.fromDate(new Date(updateData.dateOfExpiryMap.expirationYm));
    }
    await updateDoc(
      doc(db, `/pointData/${tenantId}/ptCategorySettings/${data.id}`),
      updateData)
  },

  // ポイントカテゴリ設定登録
  addPtCategorySettings: async (tenantId: string, data: PtCategorySettings): Promise<void> => {
    console.log("pointData addPtCategorySettings access");
    // tenantId = "O99900000001-awaet"; //テスト用コード。削除する
    const updateData: any = {
      tenantId: tenantId,
      categoryId: data.categoryId,
      categoryName: data.categoryName,
      limitPointFlg: data.limitPointFlg,
      expireFlg: data.expireFlg,
      createAt: new Date(),
      updateAt: new Date(),
    };
    if (data.limitPointFlg === true) {
      updateData.numberOfGrantsMap = data.numberOfGrantsMap;
    }
    if (data.expireFlg === true) {
      updateData.dateOfExpiryMap = data.dateOfExpiryMap;
    }
    if ((updateData.expireFlg === true) && (updateData.dateOfExpiryMap?.expirationUnit === 'limitMonth') && (updateData.dateOfExpiryMap.expirationYm)) {
      updateData.dateOfExpiryMap.expirationYm = Timestamp.fromDate(new Date(updateData.dateOfExpiryMap.expirationYm));
    }
    const docRef = await addDoc(
      collection(db, `/pointData/${tenantId}/ptCategorySettings`),
      updateData);
    await updateDoc(
      docRef, {id: docRef.id});
  },
  // ポイント付与項目設定新規作成
  addPtAwardedSettings: async (ptAwardedSettings: PtAwardedSettings) => {
    console.log("pointData addPtAwardedSettings access");
    try {
      const tenantId = ptAwardedSettings.tenantId;
      const cleanData = removeUndefined(ptAwardedSettings); 
      const docRef = await addDoc(collection(db, `/pointData/${tenantId}/ptAwardedSettings`), cleanData);
      console.log("PtAwardedSettings Document written with ID: ", docRef.id);
      await updateDoc(docRef,{id:docRef.id});
      return docRef.id;
    } catch (err: any) {
      throw err;
    }
  },
  // ボーナスポイント設定取得
  getPtBonusSettings: async (tenantId: string, ptAwardedId: string) => {
    console.log("pointData getptBonusSettings access");
    const docsRef = await getDocs(
      query(
        collection(db, `pointData/${tenantId}/ptAwardedSettings/${ptAwardedId}/ptBonusSettings`),
        ...[orderBy("no", "asc")]
      )
    );
    return docsRef.docs.map((doc) => ptBonusSettingsTimestampToDate(doc.data() as PtBonusSettings));
  },
  // ボーナスポイント設定新規作成
  addPtBonusSettings: async (ptBonusSettings: PtBonusSettings) => {
    console.log("pointData addPtBonusSettings access");
    try {
      const tenantId = ptBonusSettings.tenantId;
      const cleanData = removeUndefined(ptBonusSettings);
      const ptAwardedId = ptBonusSettings.ptAwardedId
      const docRef = await addDoc(collection(db, `/pointData/${tenantId}/ptAwardedSettings/${ptAwardedId}/ptBonusSettings`), cleanData);
      console.log("PtBonusSettings Document written with ID: ", docRef.id);
      await updateDoc(docRef,{id:docRef.id});
      return docRef.id;
    } catch (err: any) {
      throw err;
    }
  },
  // ポイント付与項目設定削除
  deletePtAwardedSettings: async (tenantId: string, ptAwardedId: string) : Promise<void> => {
    try {
      // 追加されているボーナスポイント設定を削除
      await pointDataQuery.getPtBonusSettings(tenantId, ptAwardedId).then((resolve) => {
          resolve.map(async (value) => {
            await deleteDoc(doc(db, `pointData/${tenantId}/ptAwardedSettings/${ptAwardedId}/ptBonusSettings/`, value.id));
        });
      });
      // 追加されているポイント付与項目設定を削除
      await deleteDoc(doc(db, `pointData/${tenantId}/ptAwardedSettings/${ptAwardedId}`));
    } catch (err: any) {
      console.error(err);
    }
  },
  // ボーナスポイント設定削除
  deletePtBonusSettings: async (tenantId: string, ptAwardedId: string) : Promise<void> => {
    try {
      // 追加されているボーナスポイント設定を削除
      await pointDataQuery.getPtBonusSettings(tenantId, ptAwardedId)
        .then((resolve) => {
          resolve.map(async (value) => {
            await deleteDoc(doc(db, `pointData/${tenantId}/ptAwardedSettings/${ptAwardedId}/ptBonusSettings/`, value.id));
        });
      });
    } catch (err: any) {
      console.error(err);
    }
  },
  // ポイント付与項目設定登録
  registPtAwardedSettings: async (ptAwardedSettings: PtAwardedSettings, ptBonusSettingsList: PtBonusSettings[], stepRangeMap:{}) => {
    console.log("pointData registPtAwardedSettings access");
    let ptAwardedId = "";
    const tenantId = ptAwardedSettings.tenantId;
    const typeId = ptAwardedSettings.typeId;
    try {
      // ポイント付与項目設定を追加する。
      ptAwardedId = await pointDataQuery.addPtAwardedSettings(ptAwardedSettings);
      console.log("PtAwardedSettings Document written with ID: ", ptAwardedId);
      if(typeId == PointTypeId.STEPS_RANGE){
        //歩数範囲を追加する。
        const userDocRef = doc(db, `pointData/${tenantId}/ptAwardedSettings`, ptAwardedId);
        await updateDoc(userDocRef, {
          rangeStepsMap: stepRangeMap,
        });
      }
      // ボーナスポイント設定を追加する。
      ptBonusSettingsList.forEach(async (ptBonusSettings) => {
        ptBonusSettings.ptAwardedId = ptAwardedId;
        const docRefId = await pointDataQuery.addPtBonusSettings(removeUndefined(ptBonusSettings));
        console.log("PtBonusSettings Document written with ID: ", docRefId);
      });
    } catch (err: any) {
      // ポイント付与項目設定を追加が完了している場合
      if (ptAwardedId !== "") {
        // 追加されているポイント付与項目設定を削除
        pointDataQuery.deletePtAwardedSettings(tenantId, ptAwardedId);
      }
      throw err;
    }
    return ptAwardedId;
  },
  // ポイント付与項目設定更新
  updatePtAwardedSettings: async (ptAwardedSettings: PtAwardedSettings, ptBonusSettingsList: PtBonusSettings[], stepRangeMap:{}) => {
    console.log("pointData updatePtAwardedSettings access");
    const ptAwardedId = ptAwardedSettings.id;
    const tenantId = ptAwardedSettings.tenantId;
    const typeId = ptAwardedSettings.typeId;
    try {
      // ボーナスポイント設定を削除する。
      await pointDataQuery.deletePtBonusSettings(tenantId, ptAwardedId);
      // ポイント付与項目設定を更新する。
      const updateDataDeleteField : any = {
        basePoint : deleteField(), // ポイント数
        registWtPoint : deleteField(), // ポイント数（体重登録）
        registBpPoint : deleteField(), // ポイント数（血圧登録）
        registSamePoint : deleteField(), // ポイント数（同時登録）
        activityTime : deleteField(), // 活動時間
        target : deleteField(), // 付与対象
        validPeriodDateFrom : deleteField(), // 有効期間（開始）
        validPeriodDateTo : deleteField(), // 有効期間（終了）
        steps : deleteField(), // 歩数
        //rangeStepsLower : deleteField(), // 歩数（下限）
        //rangeStepsUpper : deleteField(), // 歩数（上限）
        rangeStepsUnit : deleteField(), // 歩数範囲単位
        rangeStepsPeriodDateFrom : deleteField(), // 歩数範囲開始年月日
        rangeStepsPeriodDateTo : deleteField(), // 歩数範囲終了年月日
        numberLimitMap : deleteField(), // 付与回数制限設定
        pointLimitMap : deleteField(), // ポイント数合計上限設定
      }
      const updateData = removeUndefined({ ...updateDataDeleteField, ...ptAwardedSettings });
      await updateDoc(
        doc(db, `/pointData/${tenantId}/ptAwardedSettings/${ptAwardedId}`),
        updateData);
      if(typeId == PointTypeId.STEPS_RANGE){
        //歩数範囲を更新する。
        const userDocRef = doc(db, `pointData/${tenantId}/ptAwardedSettings`, ptAwardedId);
        await updateDoc(userDocRef, {
          rangeStepsMap: stepRangeMap,
        });
      }
      // ボーナスポイント設定を追加する。
      ptBonusSettingsList.forEach(async (ptBonusSettings) => {
        ptBonusSettings.ptAwardedId = ptAwardedId;
        const docRefId = await pointDataQuery.addPtBonusSettings(ptBonusSettings);
        console.log("PtBonusSettings Document written with ID: ", docRefId);
      });
    } catch (err: any) {
      throw err;
    }
    return ptAwardedId;
  },
  //歩数範囲設定登録
  rangeStepsSettings:async (tenantId: string, id: string, stepRangeMap: {}) => {
    const userDocRef = doc(db, `pointData/${tenantId}/ptAwardedSettings`, id);
    await updateDoc(userDocRef, {
      rangeStepsMap: stepRangeMap,
    });
  },
  //ポイント履歴のデータを取得
  getPointHistoryData: async (tenantId: string, id:string) => {
    console.log("pointData getPointHistoryData access");
      const docsRef = await getDoc(doc(db, `pointData/${tenantId}/pointHistory`, id));
      return pointDataTimestampToDate(docsRef.data());
  },

  //予定表に紐づくポイント履歴を取得
  getMessagePointHistoryList: async (tenantId: string, messageId: string): Promise<any | PointHistoryData> => {
    console.log("pointData getMessagePointHistoryList access");
      const docsRef = await getDocs(
        query(
          collection(db, `pointData/${tenantId}/pointHistory`),
          where('eventMsgId', '==', messageId),
        )
      );
      return docsRef.docs.map((doc) => pointDataTimestampToDate(doc.data()));
  },

  //ポイント履歴更新
  updatedPointHistoryList: async (updatedPointHistoryList: PointHistoryData[]) => {
    const batch = writeBatch(db);
    updatedPointHistoryList.forEach((pointHistory) => {
      const docRef = doc(db, `pointData/${pointHistory.tenantId}/pointHistory`, pointHistory.id);
      batch.update(docRef, pointHistory);
    });
    await batch.commit();
  },
};

// undefinedのフィールドを削除する
function removeUndefined(obj: any): any {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined));
}

export default pointDataQuery;